import React from "react";
import { Card, Skeleton } from "stories/Admin";
import styles from "./AdminPageSkeleton.module.scss";

const AdminPageSkeleton: React.FC = () => {
  return (
    <div
      className={styles.wrap}
      aria-busy="true"
      aria-label="Laster moské-info"
    >
      <Skeleton width={180} height={14} />
      <Skeleton width={260} height={32} />
      <div className={styles.columns}>
        {[0, 1].map((col) => (
          <div key={col} className={styles.column}>
            {[0, 1].map((card) => (
              <Card key={card}>
                <Skeleton width={140} height={18} />
                <Skeleton height={42} radius={12} />
                <Skeleton height={42} radius={12} />
              </Card>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminPageSkeleton;
